import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useFormik } from "formik";
import * as Yup from "yup";

import { addmemberAsync, selectMessage } from "../../features/auth/authSlice";

import BackButton from "../BackButton.js";

const AddMember = () => {
    const form = useRef();
    const checkBtn = useRef();
    const [successful, setSuccessful] = useState(false);

    const message = useSelector(selectMessage);
    const dispatch = useDispatch();

    let navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        username: Yup.string()
            .required("Username is required")
            .min(6, "Username must be at least 6 characters")
            .max(20, "Username must not exceed 20 characters"),
        email: Yup.string()
            .required("Email is required")
            .email("Email is invalid"),
        password: Yup.string()
            .required("Password is required")
            .min(6, "Password must be at least 6 characters")
            .max(40, "Password must not exceed 40 characters"),
        roles: Yup.array(),
    });

    const formik = useFormik({
        initialValues: {
            username: "",
            email: "",
            password: "",
            roles: ["user"],
        },
        validationSchema,
        // validateOnChange: false,
        // validateOnBlur: false,
        onSubmit: (user) => {
            dispatch(addmemberAsync(user))
                .then(() => {
                    setSuccessful(true);
                    navigate("/members");
                })
                .catch(() => {
                    setSuccessful(false);
                });
        },
        onReset: () => {
            navigate("/members");
        },
    });

    const [pswType, setPswType] = useState("password");

    const toggleShowPsw = () => {
        if (pswType === "password") {
            setPswType("text");
        } else {
            setPswType("password");
        }
    };

    return (
        <div className="col-md-12 module-form">
            <BackButton returnPath="/members"></BackButton>

            <h4 className="page-title">Add member</h4>

            <form onSubmit={formik.handleSubmit} ref={form}>
                {!successful && (
                    <div>
                        <div className="form-group">
                            <label htmlFor="username"> Username </label>
                            <input
                                name="username"
                                type="text"
                                className={
                                    "form-control" +
                                    (formik.errors.username &&
                                    formik.touched.username
                                        ? " is-invalid"
                                        : "")
                                }
                                onChange={formik.handleChange}
                                value={formik.values.username}
                            />
                            <div className="invalid-feedback">
                                {formik.errors.username &&
                                formik.touched.username
                                    ? formik.errors.username
                                    : null}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="email"> Email </label>
                            <input
                                name="email"
                                type="email"
                                className={
                                    "form-control" +
                                    (formik.errors.email && formik.touched.email
                                        ? " is-invalid"
                                        : "")
                                }
                                onChange={formik.handleChange}
                                value={formik.values.email}
                            />
                            <div className="invalid-feedback">
                                {formik.errors.email && formik.touched.email
                                    ? formik.errors.email
                                    : null}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="password"> Password </label>
                            <div className="input-group">
                                <input
                                    name="password"
                                    type={pswType}
                                    className={
                                        "form-control" +
                                        (formik.errors.password &&
                                        formik.touched.password
                                            ? " is-invalid"
                                            : "")
                                    }
                                    onChange={formik.handleChange}
                                    value={formik.values.password}
                                    autoComplete={"new-password"}
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    onClick={toggleShowPsw}
                                    style={{ borderRadius: "0 6px 6px 0" }}
                                >
                                    {pswType === "password" ? (
                                        <i class="bi bi-eye" />
                                    ) : (
                                        <i class="bi bi-eye-slash" />
                                    )}
                                </button>
                                <div className="invalid-feedback">
                                    {formik.errors.password &&
                                    formik.touched.password
                                        ? formik.errors.password
                                        : null}
                                </div>
                            </div>
                        </div>

                        <hr></hr>

                        <div className="form-group">
                            <button type="submit" className="btn btn-success">
                                Save
                            </button>{" "}
                            <button
                                type="button"
                                className="btn btn-danger float-right"
                                onClick={formik.handleReset}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                {/* {message && (
                    <div className="form-group">
                        <div
                            className={
                                successful
                                    ? "alert alert-success"
                                    : "alert alert-danger"
                            }
                            role="alert"
                        >
                            {message}
                        </div>
                    </div>
                )}
                <button style={{ display: "none" }} ref={checkBtn}></button> */}
            </form>
        </div>
    );
};

export default AddMember;
